import BlogGridInner from "../components/BlogGridInner";
import FooterThree from "../components/FooterThree";
import HeaderThree from "../components/HeaderThree";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";

const BlogPage = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      <HeaderThree />


      {/* BlogGridInner */}
      <BlogGridInner />

      {/* FooterOne */}
     <FooterThree />
    </>
  );
};

export default BlogPage;
